module.exports = __webpack_public_path__ + "static/img/Orion Logo.d3c322ce.svg";